// apps/scheduler-worker/src/components/AppShell.tsx
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { BottomNav } from './BottomNav';
import { OfflineIndicator } from './OfflineIndicator';
import { useSyncService } from '../hooks/useSyncService';
import { useMyTasksWebSocket } from '../hooks/useMyTasksWebSocket';

export function AppShell() {
  // useSyncService handles online detection, pending count, and auto-sync on reconnect
  const { isOnline, pendingCount } = useSyncService();

  // WebSocket for real-time task updates
  // Automatically connects when online, handles offline gracefully
  const { isConnected: wsConnected, error: wsError } = useMyTasksWebSocket({
    enabled: true,
  });

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header title="My Tasks" />
      <OfflineIndicator
        isOffline={!isOnline}
        pendingCount={pendingCount}
        wsConnected={wsConnected}
        wsError={wsError}
      />

      <main className="flex-1 pb-20 overflow-y-auto">
        <Outlet />
      </main>

      <BottomNav />
    </div>
  );
}
